import { useSyncExternalStore } from "react";
import { type NativeCameraSnapshot, nativeCamera } from "./nativeCamera";

export function useNativeCameraSnapshot(): NativeCameraSnapshot {
	return useSyncExternalStore(nativeCamera.subscribe, nativeCamera.getSnapshot, nativeCamera.getSnapshot);
}

const getSlotActive = () => nativeCamera.getSnapshot().slotActive;
const getServerSlotActive = () => false;

/** True while a page shows the native preview through a see-through slot. */
export function useNativeCameraSlotActive(): boolean {
	return useSyncExternalStore(nativeCamera.subscribe, getSlotActive, getServerSlotActive);
}
